import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { Container, AbilityForm, Label, NormalLabel, Input, TextArea, FormRow, AbilityItem, AbilityName, AbilityVariablesWrapper, AbilityVariablesItem, AbilityLabel } from './Abilities.styles';
import { Button, ButtonRow, ButtonIcon } from '../../styles/globalComponents';
import { parseMacroAndSendToChat } from '../TemplateBuilder/SheetBuilder/Util/MacroParser';
import T from '../i18n/i18n';

const getAbilityIndex = (abilities, abilityId) => {
    let index = 0;
    for (let i in abilities) {
        if (abilities[i].id === abilityId) {
            index = i;
            break;
        }
    }

    return parseInt(index);
}

export default ({value, onChange, sheetValues, charId}) => {
    const [abilities, setAbilities] = useState([]);
    const [abilitiesValues, setAbilitiesValues] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [formId, setFormId] = useState('');
    const [formName, setFormName] = useState('');
    const [formMacro, setFormMacro] = useState('');
    const [formVars, setFormVars] = useState([]);
    const [sheetValuesResult, setSheetValuesResult] = useState({});
    const [isConfig, setIsConfig] = useState(false);

    const sheetOpenedValues = useSelector(state => state.charactersState.sheetOpenedValues);
    const sheetCharId = useSelector(state => state.charactersState.sheetCharId);
    const abilitiesUndo = useRef([]);

    useEffect(() => {
        setSheetValuesResult(sheetValues);
    }, [sheetValues]);

    useEffect(() => {
        if (charId === sheetCharId && Object.keys(sheetOpenedValues).length) {
            setSheetValuesResult(sheetOpenedValues);
        }
    }, [sheetOpenedValues, charId, sheetCharId]);

    useEffect(() => {
        if (value) {
            setAbilities(value);
        }
    }, [value]);

    const handleCreateNew = () => {
        setFormId(null);
        setShowForm(true);
    }

    const handleOpenConfig = () => {
        abilitiesUndo.current = [...abilities];
        setIsConfig(true);
    }

    const handleCancelConfig = () => {
        setAbilities([...abilitiesUndo.current]);
        setIsConfig(false);
    }

    const handleSaveConfig = () => {
        if (onChange) {
            onChange(abilities);
        }

        setIsConfig(false);
    }

    const moveUp = (abilityId) => {
        let index = getAbilityIndex(abilities, abilityId);
        let abilitiesChanged = [...abilities];
        
        if (index > 0) {
            let aux = {...abilitiesChanged[index-1]};
            abilitiesChanged[index-1] = {...abilitiesChanged[index]};
            abilitiesChanged[index] = aux;
        }
        
        setAbilities(abilitiesChanged);
    }

    const moveDown = (abilityId) => {
        let index = getAbilityIndex(abilities, abilityId);
        let abilitiesChanged = [...abilities];
        
        if (index < (abilities.length-1)) {
            let aux = {...abilitiesChanged[index+1]};
            abilitiesChanged[index+1] = {...abilitiesChanged[index]};
            abilitiesChanged[index] = aux;
        }

        setAbilities(abilitiesChanged);
    }

    const openAbility = (id) => {
        setFormId(id);
        for(let ability of abilities) {
            if (ability.id === id) {
                setFormName(ability.name);
                setFormMacro(ability.macro);
                setFormVars(ability.vars);
                break;
            }
        }
        setShowForm(true);
    }

    const runMacro = (ability, abilityIndex) => {
        if (!ability.macro) {
            return;
        }

        let values = {...sheetValuesResult};
        values['token'] = charId;

        values = {...values, ...{var0:0, var1:0, var2:0, var3:0, var4:0}}

        for(let i=1; i<=ability.vars.length; i++) {
            values['var'+i] = abilitiesValues[abilityIndex] ? (abilitiesValues[abilityIndex][i-1] || '0') : '0';
        }

        parseMacroAndSendToChat(ability.macro, values);
    }

    const handleCancel = () => {
        clearForm();
        setShowForm(false);
    }

    const handleSave = () => {
        let result = [];
        if (formId) {
            result = abilities.map(i => i.id === formId ? getValue() : i)
        } else {
            result = [...abilities, getValue()];
        }

        setAbilities(result);
        setShowForm(false);
        clearForm();

        if (onChange) {
            onChange(result);
        }
    }

    const handleRemove = () => {
        let newAbilities = [];
        if (formId) {
            newAbilities = abilities.filter(i => i.id !== formId);
            setAbilities(newAbilities);
        } else {
            newAbilities = [...abilities];
        }

        setShowForm(false);
        clearForm();

        if (onChange) {
            onChange(newAbilities);
        }
    }

    const clearForm = () => {
        setFormName('');
        setFormMacro('');
        setFormVars([]);
    }

    const addVar = () => {
        setFormVars([...formVars, '']);
    }

    const removeVar = (i) => {
        setFormVars(current => {
            let result = [...current]
            result.splice(i, 1);
            return result;
        });
    }

    const getValue = () => {
        return {
            id: formId || (new Date()).getTime(),
            name: formName,
            macro: formMacro,
            vars: formVars
        }
    }

    const setVarValue = (i, value) => {
        setFormVars(current => current.map((v, j) => i === j ? value : v));
    }

    const handleChangeName = (val) => {
        setFormName(val);
    }

    const handleChangeMacro = (val) => {
        setFormMacro(val);
    }

    const getAbilityInputValue = (abilityIndex, inputIndex) => {
        if (!abilitiesValues[abilityIndex]) {
            return '';
        }

        return abilitiesValues[abilityIndex][inputIndex] || '';
    }

    const setAbilityInputValue = (abilityIndex, inputIndex, value) => {
        setAbilitiesValues(old => {
            let values = [...old];

            if (!values[abilityIndex]) {
                values[abilityIndex] = [];
            }

            values[abilityIndex][inputIndex] = value;

            return values;
        })
    }

    return <Container className="scrollbar">
        {!showForm && <>
            {abilities.map((ability, i) => <AbilityItem key={i}>
                <AbilityName>
                    {ability.name}
                </AbilityName>
                <AbilityVariablesWrapper>
                    {ability.vars.map((v,j) => <AbilityVariablesItem key={j}>
                        <AbilityLabel>{v}</AbilityLabel>
                        <Input value={getAbilityInputValue(i, j)} onChange={(e) => setAbilityInputValue(i, j, e.target.value)} className='tiny' />
                    </AbilityVariablesItem>)}
                </AbilityVariablesWrapper>

                {isConfig ? <>
                    <ButtonIcon onClick={() => moveUp(ability.id)} color="#3af" icon="\F0737" />
                    <ButtonIcon onClick={() => moveDown(ability.id)} color="#3fa" icon="\F072E" />
                </> : <>
                    <ButtonIcon onClick={() => runMacro(ability, i)} color="#92f" icon="\F076E" />
                    <ButtonIcon onClick={() => openAbility(ability.id)} color="#29f" icon="\F03EB" />
                </>}
            </AbilityItem>)}
            {!isConfig ? <ButtonRow>
                <Button color="#090" onClick={handleCreateNew}><T value={"characters.newability"} /></Button>
                <ButtonIcon color="#05f" icon="\F0493" onClick={()=>{handleOpenConfig()}} />
            </ButtonRow> : <ButtonRow>
                <Button color="#090" onClick={handleSaveConfig}><T value={"save"} /></Button>
                <Button color="#f33" onClick={handleCancelConfig}><T value={"cancel"} /></Button>
            </ButtonRow>}
        </>}
        {showForm && <>
            <AbilityForm>
                <FormRow>
                    <Label><T value={"characters.abilityname"} /></Label>
                </FormRow>
                <FormRow>
                    <Input value={formName} autocomplete="off" onChange={(e) => {handleChangeName(e.target.value)}}/>
                </FormRow>
                <FormRow>
                    <Label><T value={"characters.abilitymacro"} /></Label>
                </FormRow>
                <TextArea value={formMacro} onChange={(e) => {handleChangeMacro(e.target.value)}}/>
                <FormRow>
                    <Label><T value={"characters.abilityvars"} /></Label>
                    <Label><T value={"characters.abilitydesc"} /></Label>
                </FormRow>
                {formVars.map((val, i) => <FormRow className="spaced hideButton" key={i}>
                    <ButtonIcon onClick={() => removeVar(i)} color="#f92" icon="\F0156" />
                    <NormalLabel>[var{i+1}]</NormalLabel>
                    <Input value={val} onChange={(e) => {setVarValue(i, e.target.value)}} className="nomargin"/>
                </FormRow>)}
                <FormRow className="spaced">
                    <ButtonIcon onClick={addVar} color="#0a0" icon="\F0415" />
                    <Label className="varibles"><T value={"characters.abilityaddnewvalue"} /></Label>
                </FormRow>
            </AbilityForm>
            <ButtonRow>
                <Button color={formId ? "#26f" : "#0c0" } onClick={handleSave}><T value={formId ? 'edit' : 'add' } /></Button>
                {formId && <Button color="#fa2" onClick={handleRemove}><T value={"delete"} /></Button>}
                <Button color="#f33" onClick={handleCancel}><T value={"cancel"} /></Button>
            </ButtonRow>
        </>}
    </Container>
};